import React, { useEffect } from 'react';

import { useUploadImages } from 'services/image/useUploadImages';

const MAX_PHOTOS_COUNT = 1;
const MAX_PHOTO_SIZE = 15 * 1024 * 1024;

interface ImageUploadProps {
  onImageUploaded: (url: string) => void;
  inputRef: React.RefObject<HTMLInputElement>;
}

export const UserPhotoUploader = ({ onImageUploaded, inputRef }: ImageUploadProps) => {
  const { photos, addPhoto } = useUploadImages('USER', [], {
    maxNumberOfImages: MAX_PHOTOS_COUNT,
    maxFileSizeInBytes: MAX_PHOTO_SIZE,
  });

  const handleAddImg = async (e: React.ChangeEvent<HTMLInputElement>) => {
    Array.from(e.target.files || []).forEach(file => addPhoto(file));
    e.target.value = '';
  };

  useEffect(() => {
    const uploaded = photos.find(photo => !photo.isUploading && photo.url);
    if (uploaded) {
      onImageUploaded(uploaded.url!);
    }
  }, [photos]);

  return (
    <input
      ref={inputRef}
      type='file'
      data-testid='img-input'
      accept='image/jpeg, image/png, image/heic'
      style={{ display: 'none' }}
      onChange={handleAddImg}
    />
  );
};
